import { Component, HostListener, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: '[miqInputIconHandler]',
  template: `<mat-icon
      *ngIf="miqInputIconHandler?.tooltipTranslation != null; else noTranslateTooltip"
      class="mat-icon"
      [matTooltip]="miqInputIconHandler?.tooltipTranslation | xTranslate"
      >{{ miqInputIconHandler.icon }}</mat-icon
    >
    <ng-template #noTranslateTooltip>
      <mat-icon class="mat-icon" [matTooltip]="miqInputIconHandler?.tooltip ?? ''">{{
        miqInputIconHandler.icon
      }}</mat-icon>
    </ng-template>`,
  standalone: false,
})
export class InputIconHandlerComponent {
  @Input() control: AbstractControl = null;
  @Input() miqInputIconHandler: {
    icon: string;
    handle: (control: AbstractControl) => void;
    tooltipTranslation?: string;
    tooltip?: string;
  } | null = null;

  @HostListener('click', ['$event'])
  onClick(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    this.miqInputIconHandler.handle(this.control);
  }
}
